import HeadTermStateMobileNavMenu from 'HeadTermStateMobileNavMenu';

window.HeadTermStateMobileNavMenu = HeadTermStateMobileNavMenu;



// WEBPACK FOOTER //
// ./src-assets/js/head-term-state-navbar-mobile.js